/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceDateRangeScheduleDto } from '../../models/device-date-range-schedule-dto';
import { DeviceDayScheduleDto } from '../../models/device-day-schedule-dto';
import { DeviceScheduleEntryDto } from '../../models/device-schedule-entry-dto';

export interface DeviceControllerAddSchedule$Params {
  deviceId: string;
  clientWorkspaceId: string;
      body: (DeviceDateRangeScheduleDto | DeviceDayScheduleDto)
}

export function deviceControllerAddSchedule(http: HttpClient, rootUrl: string, params: DeviceControllerAddSchedule$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceScheduleEntryDto>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerAddSchedule.PATH, 'post');
  if (params) {
    rb.path('deviceId', params.deviceId, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceScheduleEntryDto>;
    })
  );
}

deviceControllerAddSchedule.PATH = '/api/device/{clientWorkspaceId}/{deviceId}/schedules';
